var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagearrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.638 6.889a1.267 1.267 0 000-1.777L9.965.368a1.23 1.23 0 00-1.754 0 1.267 1.267 0 000 1.78l2.558 2.595H1.24a1.23 1.23 0 00-.876.368 1.267 1.267 0 000 1.778c.232.236.548.369.876.369h9.53L8.211 9.853a1.259 1.259 0 00-.363.89 1.274 1.274 0 00.363.889 1.239 1.239 0 00.877.368 1.224 1.224 0 00.877-.368l4.673-4.743z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagearrow);
export default ForwardRef;